var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDafiLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 36,
    viewBox: "0 0 110 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7312 0C21.6877 0 20.8418 0.84581 20.8418 1.88929V22.0118V10.5552C20.8418 10.5552 19.4861 9.65362 17.6829 9.05177C16.3362 8.6023 14.6424 8.40749 13.6043 8.40745C6.10698 8.40745 0 14.5145 0 22.0118C0 29.509 6.10698 35.6162 13.6043 35.6162C21.1017 35.6162 26.9367 29.509 26.9367 22.0118V1.88929C26.9367 0.84581 26.0909 0 25.0474 0H22.7312ZM13.6571 14.4767C17.8296 14.4767 20.8146 17.8393 20.8146 22.0118C20.8146 23.9593 20.1641 25.7309 19.0461 27.0657C17.7689 28.5911 15.882 29.5467 13.6571 29.5467C9.48454 29.5467 6.12198 26.1842 6.12194 22.0118C6.12194 17.8393 9.48454 14.4767 13.6571 14.4767Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6043 8.40747C6.10698 8.40747 0 14.5145 0 22.0118C0 29.5091 6.10698 35.6162 13.6043 35.6162C21.1017 35.6162 26.9367 29.5091 26.9367 22.0118H20.8418V10.5553C20.6385 10.422 20.5413 10.3487 20.2203 10.172C18.2597 9.09274 16.0324 8.40747 13.6043 8.40747ZM13.6571 14.4767C17.8296 14.4767 20.8146 17.8393 20.8146 22.0118C20.8146 23.9593 20.1641 25.7309 19.0461 27.0657C17.7689 28.5911 15.882 29.5468 13.6571 29.5468C9.48454 29.5468 6.12198 26.1842 6.12194 22.0118C6.12194 17.8393 9.48458 14.4767 13.6571 14.4767Z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7598 5.80103H50.2294C52.9703 5.80103 55.3929 6.32401 57.4969 7.36994C59.6008 8.4159 61.2356 9.88867 62.4018 11.7882C63.5679 13.6878 64.1514 15.8999 64.1514 18.4246C64.1514 20.9493 63.5679 23.1614 62.4018 25.0611C61.2356 26.9607 59.6008 28.4331 57.4969 29.4791C55.3929 30.525 52.9703 31.048 50.2294 31.048H38.7598V5.80103ZM49.9405 26.2512C52.4655 26.2512 54.4791 25.548 55.9818 24.1415C57.4848 22.7346 58.2362 20.8291 58.2362 18.4246C58.2362 16.0201 57.4848 14.1146 55.9818 12.7079C54.4791 11.3013 52.4655 10.598 49.9405 10.598H44.6025V26.2512H49.9405Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.7685 11.644V31.0481H81.3944V28.8119C80 30.4953 77.9801 31.3369 75.335 31.3369C73.5078 31.3369 71.8548 30.9279 70.3757 30.1107C68.8971 29.2931 67.7368 28.1269 66.8955 26.6118C66.0539 25.0972 65.6328 23.3417 65.6328 21.3461C65.6328 19.3504 66.0539 17.5951 66.8955 16.0803C67.7368 14.5655 68.8971 13.3993 70.3757 12.5817C71.8548 11.7642 73.5078 11.3555 75.335 11.3555C77.8119 11.3555 79.7476 12.1369 81.1421 13.6999V11.644H86.7685ZM76.3088 26.72C77.7278 26.72 78.9059 26.2331 79.8437 25.2596C80.7811 24.2858 81.2502 22.9812 81.2502 21.3461C81.2502 19.7111 80.7811 18.4066 79.8437 17.4328C78.9059 16.459 77.7278 15.9721 76.3088 15.9721C74.8663 15.9721 73.6761 16.459 72.7383 17.4328C71.8005 18.4066 71.3318 19.7111 71.3318 21.3461C71.3318 22.9812 71.8005 24.2858 72.7383 25.2596C73.6761 26.2331 74.8663 26.72 76.3088 26.72Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9661 12.0769L107.504 12.077L107.246 16.405L95.1103 16.405V31.0482H89.4839V11.2113C89.4839 8.99914 90.1391 7.24387 91.4494 5.94544C92.7602 4.64702 94.6056 3.9978 96.9859 3.9978C97.8276 3.9978 98.627 4.08798 99.3845 4.26833C100.142 4.44864 100.773 4.70715 101.278 5.04377L99.7994 9.11936C99.15 8.66252 98.3924 8.43409 97.5271 8.43409C95.8198 8.43409 94.9661 9.37186 94.9661 11.2473V12.0769Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.688 12.0789H109.315V31.0486H103.688V12.0789Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.501 8.93905C105.467 8.93905 104.626 8.63849 103.977 8.03734C103.327 7.43624 103.003 6.69085 103.003 5.80119C103.003 4.9115 103.327 4.16614 103.977 3.565C104.626 2.96386 105.467 2.66333 106.501 2.66333C107.535 2.66333 108.377 2.95184 109.026 3.52895C109.675 4.10601 110 4.82737 110 5.69299C110 6.63072 109.675 7.40616 109.026 8.01932C108.377 8.63248 107.535 8.93905 106.501 8.93905Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 21.6257,
    y1: 4.18779,
    x2: 2.78587,
    y2: 33.0175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525336,
    stopColor: "#00F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23FCCF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1379 9.90351) scale(26.795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060606",
    stopOpacity: 0.476377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.110106,
    stopColor: "#030509",
    stopOpacity: 0.253808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45098,
    stopColor: "#00040C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659125,
    stopColor: "#144A4C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AFDC5",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDafiLogo);
export default __webpack_public_path__ + "static/media/dafi-logo.513d656c0fc5a36663ad7aef282856eb.svg";
export { ForwardRef as ReactComponent };